import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  DealBookEntry,
  EntityMeta,
  Message,
  WebsocketQuery,
} from '@qtek/shared/models';

export const ParticipantActions = createActionGroup({
  source: 'Participant',
  events: {
    // Investor List Actions
    'Subscribe Deal Book List': props<{
      query: WebsocketQuery[];
      viewId: string;
    }>(),
    'Unsubscribe Deal Book List': props<{ viewId: string }>(),
    'Get Deal Book List': props<{ query: WebsocketQuery[]; viewId: string }>(),
    'Get Deal Book List Success': props<{
      payload: DealBookEntry[];
      meta: EntityMeta;
    }>(),
    'Get Deal Book List Failure': props<{ error: any }>(),
    'Create Deal Book': props<{ payload: any[] }>(),
    'Create Deal Book Success': props<{
      payload: DealBookEntry;
      message: Message;
    }>(),
    'Create Deal Book Failure': props<{ error: any }>(),
    'Update Deal Book': props<{
      res: DealBookEntry;
      viewId: string;
      id: string;
    }>(),
    'Update Deal Book Success': props<{
      payload: DealBookEntry;
      message: Message;
    }>(),
    'Update Deal Book Failure': props<{ error: any }>(),
    'Delete Deal Book': props<{ res: DealBookEntry; viewId: string }>(),
    'Delete Deal Book Success': props<{ payload: any; message: Message }>(),
    'Delete Deal Book Failure': props<{ error: any }>(),

    // Investor Actions
    'Subscribe Investor List': props<{
      query: WebsocketQuery[];
      viewId: string;
      withoutQuery?: boolean;
    }>(),
    'Unsubscribe Investor List': props<{ viewId: string }>(),
    'Get Investor List': props<{ query: WebsocketQuery[]; viewId: string }>(),
    'Get Investor List Success': props<{ payload: DealBookEntry[] }>(),
    'Get Investor List Failure': props<{ error: any }>(),
    'Add Investor': props<{ res: any[]; queryId: string; viewId: string }>(),
    'Add Investor Success': props<{ payload: DealBookEntry }>(),
    'Add Investor Failure': props<{ error: any }>(),
    'Update Investor': props<{
      res: any;
      queryId: string;
      viewId: string;
      id: string;
    }>(),
    'Update Investor Success': props<{ payload: DealBookEntry }>(),
    'Update Investor Failure': props<{ error: any }>(),
    'Delete Investor': props<{ queryId: string; viewId: string; id: string }>(),
    'Delete Investor Success': props<{ payload: any; message: Message }>(),
    'Delete Investor Failure': props<{ error: any }>(),

    // Sales Pipeline Actions
    'Subscribe Sales Pipeline List': props<{
      query: WebsocketQuery[];
      viewId: string;
    }>(),
    'Unsubscribe Sales Pipeline List': props<{ viewId: string }>(),
    'Get Sales Pipeline List': props<{
      query: WebsocketQuery[];
      viewId: string;
    }>(),
    'Get Sales Pipeline List Success': props<{
      res: DealBookEntry[];
      meta?: EntityMeta;
    }>(),
    'Get Sales Pipeline List Failure': props<{ error: any }>(),
    'Create Sales Pipeline': props<{ payload: any[] }>(),
    'Create Sales Pipeline Success': props<{ payload: DealBookEntry }>(),
    'Create Sales Pipeline Failure': props<{ error: any }>(),
    'Update Sales Pipeline': props<{
      res: DealBookEntry;
      viewId: string;
      id: string;
    }>(),
    'Update Sales Pipeline Success': props<{ payload: DealBookEntry }>(),
    'Update Sales Pipeline Failure': props<{ error: any }>(),
    'Delete Sales Pipeline': props<{ res: DealBookEntry; viewId: string }>(),
    'Delete Sales Pipeline Success': props<{ payload: any }>(),
    'Delete Sales Pipeline Failure': props<{ error: any }>(),

    // Individual Investor Actions
    // 'Add Investor WS': props<{
    //   res: { email: string; itmId: string; sts: number; role: string };
    //   prms: { snd: boolean };
    // }>(),
    // 'Add Investor WS Success': props<{ payload: Investor; message: Message }>(),
    // 'Add Investor WS Failure': props<{ error: any }>(),
    // 'Add Investors WS': props<{
    //   asset: { _id: string };
    //   contacts: Array<{ refId: string; tp: 100 }>;
    // }>(),
    // 'Add Investors WS Success': props<{
    //   payload: Investor;
    //   message: Message;
    // }>(),
    // 'Add Investors WS Failure': props<{ error: any }>(),
    // 'Update Investor WS': props<{
    //   id: string;
    //   payload: any;
    //   queryId: string;
    // }>(),
    // 'Update Investor WS Success': props<{
    //   payload: Investor;
    //   message: Message;
    // }>(),
    // 'Update Investor WS Failure': props<{ error: any }>(),
    // 'Delete Investor WS': props<{ id: string; queryId: string }>(),
    // 'Delete Investor WS Success': props<{
    //   payload: Investor;
    //   message: Message;
    // }>(),
    // 'Delete Investor WS Failure': props<{ error: any }>(),
    'Resent Investor Invite': props<{ id: string }>(),
    'Resent Investor Invite Success': props<{
      message: Message;
    }>(),
    'Resent Investor Invite Failure': props<{ error: any }>(),

    // Deal Book Participants
    'Connect Deal Book List': props<{ payload: 'investor' }>(),
    'Disconnect Deal Book List': props<{ payload: any }>(),
    'Get Deal Book': props<{ p?: string; type?: string }>(),
    'Get Deal Book Success': props<{ payload: any; meta: EntityMeta }>(),
    'Get Deal Book Failure': props<{ error: any }>(),

    // Investment Actions
    'Get Invests': emptyProps(),
    'Get Invests Success': props<{ payload?: any }>(),
    'Get Invests Failure': props<{ error?: any }>(),
    'Request Invests': props<{ payload?: any }>(),
    'Request Invests Success': props<{ payload?: any; message: Message }>(),
    'Request Invests Failure': props<{ error?: any }>(),
  },
});
